import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as l, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconListening",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, _, f, a) {
  return n(), d("svg", {
    "aria-label": r.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--listening"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Listening",
    viewBox: "0 0 11 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.25 1.5A2.75 2.75 0 0 0 4.5 4.25a.5.5 0 0 1-1 0 3.75 3.75 0 0 1 7.5 0c0 .841-.212 1.495-.544 2.03-.325.523-.752.91-1.136 1.23l-.249.204c-.29.237-.53.433-.723.658-.223.26-.348.524-.348.878a2.25 2.25 0 1 1-4.5 0 .5.5 0 0 1 1 0 1.25 1.25 0 1 0 2.5 0c0-.646.25-1.132.59-1.529.256-.299.585-.567.884-.811.07-.058.14-.114.206-.17.366-.304.69-.606.926-.988.231-.372.394-.843.394-1.502A2.75 2.75 0 0 0 7.25 1.5ZM6.013 3.013A1.75 1.75 0 0 1 9 4.25a.5.5 0 0 1-1 0 .75.75 0 0 0-1.5 0v.086a1.5 1.5 0 0 1 .56.353.5.5 0 0 1-.706.707A.5.5 0 0 0 6 5.25a.5.5 0 0 1-.5-.5v-.5c0-.464.184-.91.513-1.237ZM.5 6.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm2 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm2 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const h = /* @__PURE__ */ o(c, [["render", u]]);
export {
  h as default
};
//# sourceMappingURL=listening.js.map
